import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DEMO_PATH_PREFIX } from '@app/features/tours/demo/demo-mode';
import { TourService } from '@app/features/tours/tour.service';
import { findTour } from '@app/features/tours/tours';
import { AnnouncementBanner } from '../announcement-banner/announcement-banner';
import { AnnouncementService } from '../announcement.service';

/** Les bandeaux des nouveautés, sous ceux des anomalies, qui passent devant. */
@Component({
  selector: 'app-announcement-banners',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AnnouncementBanner],
  template: `
    @if (banners().length) {
      <section class="announcement-banners" aria-label="Nouveautés">
        @for (banner of banners(); track banner.id) {
          <app-announcement-banner
            [announcement]="banner"
            [tourHref]="tourHref(banner.tourId)"
            (dismiss)="close(banner.id)"
          ></app-announcement-banner>
        }
      </section>
    }
  `,
  styles: `
    .announcement-banners {
      display: block;
    }
  `,
})
export class AnnouncementBanners implements OnInit {
  private readonly announcementService = inject(AnnouncementService);
  private readonly tours = inject(TourService);

  protected readonly banners = toSignal(this.announcementService.visible$, { initialValue: [] });

  ngOnInit(): void {
    this.announcementService.start();
  }

  /**
   * L'onglet de démonstration du parcours, s'il est au catalogue et que l'utilisateur en voit au
   * moins une étape (RG-parcours-catalogue) ; sinon, l'annonce n'a pas de « Découvrir ».
   */
  protected tourHref(tourId: string): string | null {
    const tour = findTour(tourId);
    return tour && this.tours.visibleSteps(tour).length ? DEMO_PATH_PREFIX + tour.id : null;
  }

  protected close(id: string): void {
    this.announcementService.recordOutcome(id, 'CLOSED').subscribe();
  }
}
